import React from "react";
import { AlertTriangle } from "lucide-react";
import { TID } from "@/lib/testIds";

export default function ErrorState({ message, onRetry }) {
  return (
    <div
      data-testid={TID.errorMessage}
      className="max-w-2xl mx-auto card-tactical p-6 sm:p-8 border-red-500/30 bg-red-500/5"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-md bg-red-500/10 border border-red-500/30 flex items-center justify-center shrink-0">
          <AlertTriangle className="w-4 h-4 text-red-400" strokeWidth={1.8} />
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold text-white">找不到相符的股票</div>
          <div className="mt-1 text-xs sm:text-sm text-zinc-400 leading-relaxed">
            {message ||
              "找不到符合的股票，請確認股票代碼或公司名稱是否正確。"}
          </div>
          <div className="mt-2 text-[11px] text-zinc-500 leading-relaxed">
            <span className="text-zinc-400 font-semibold">目前展示版支援：</span>
            AAPL、TSLA、NVDA、MSFT、GOOGL、META、AMZN，以及台股 2330.TW（台積電）、2317.TW（鴻海）、2454.TW（聯發科）、2308.TW（台達電）、2412.TW（中華電）、3363.TW（上詮）。
          </div>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-4 text-xs font-semibold bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-100 px-3 py-1.5 rounded-md transition-colors"
            >
              重試
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
